export default "__VITE_ASSET__C_52SpbN__"